import { useEffect, useRef } from "react";
import { useLocation, useMatches } from "react-router-dom";
import {
  installUnloadFlush,
  setCurrentRoute,
  startFlushTimer,
  trackEvent,
} from "./tracker";

const extractRouteLabel = (handle: unknown): string | null => {
  if (!handle || typeof handle !== "object") return null;
  const crumb = (handle as { crumb?: () => unknown }).crumb;
  if (typeof crumb !== "function") return null;
  try {
    const element = crumb() as { props?: { name?: unknown } } | null;
    const name = element?.props?.name;
    return typeof name === "string" ? name : null;
  } catch {
    return null;
  }
};

export const useAnalyticsTracker = () => {
  const location = useLocation();
  const matches = useMatches();
  const lastPathRef = useRef<string | null>(null);
  const lastViewAtRef = useRef<number | null>(null);

  useEffect(() => {
    startFlushTimer();
    installUnloadFlush();
  }, []);

  useEffect(() => {
    const deepest = [...matches]
      .reverse()
      .find((m) => m.id && m.id !== "root");
    const route_id = deepest?.id ?? null;
    const route_label = extractRouteLabel(deepest?.handle);

    setCurrentRoute({ path: location.pathname, route_id, route_label });

    const now = Date.now();
    const prev_duration_ms = lastViewAtRef.current
      ? now - lastViewAtRef.current
      : null;
    const referrer_path = lastPathRef.current;

    trackEvent("page_view", {
      duration_ms: prev_duration_ms,
      payload: {
        referrer_path,
        search: location.search || null,
      },
    });

    lastPathRef.current = location.pathname;
    lastViewAtRef.current = now;
  }, [location.pathname, location.search, matches]);
};
